export const messages = {
  wronggame: {
    title: "Hra neexistuje",
    message:
      "Taková hra neexistuje. Přihlas se do panelu školitele a zkus to znova.",
    event: "wronggame",
  },
  wrongcode: {
    title: "Konflikt zařízení",
    message:
      "Hra je už spuštěna na jiném zařízení. Pokud chceš spustit hru na tomhle zařízení, přihlas se do panelu školitele a vyber tuto možnost.",
    event: "wronggcode",
  },
  expired: {
    title: "Konec hry",
    message:
      "Vypršel čas hry. Přihlas se do panelu školitele a zkontroluj seznam aktivních her.",
    event: "wronggcode",
  },
  missingcredentials: {
    title: "Chybí údaje o hře",
    message:
      "Pravděpodobně se snažíš spustit hru přes odkaz, hra musí být spuštěna přes panel školitele.",
    event: "wronggcode",
  },
  diceTitle: "Hoď kostkou a vyber výsledek",
  diceOr: "NEBO",
};
export const cz = {
  tutorial: {
    Vipers: {
      name: "Hadí hnízdo",
      effect: "display",
      protection: "careful",
      protectedKarma: 1,
      badKarma1: 6,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Opatrně se prodíráš keři, slyšíš tichý šelest okolo sebe, začínáš stoupat s větší ostražitostí a pro jistotu se vzdaluješ.",
      badDescription1:
        "Prodíráš se hustými keři, slyšíš tichý šelest okolo sebe. Na kuráž si začneš zpívat, když najednou z blízkého keře s hlasitým zasyčením vyskočí zmije a bolestivě tě uštkne do lýtka.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Shrubbery: {
      name: "Trnité keře",
      effect: "display/toss",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 1,
      badKarma2: 1,
      badKarma3: 1,
      badKarma4: 1,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Kolem cesty roste mnoho trnitých keřů, stačí jeden neohrabaný pohyb a přihodíš si ošklivé zranění. Ty se ale trní ladně vyhýbáš.",
      badDescription1:
        "Kolem cesty roste mnoho trnitých keřů, stačí jeden neohrabaný pohyb a přihodíš si ošklivé zranění. Ty se ale trní ladně vyhýbáš.",
      badDescription2:
        "Kolem cesty roste mnoho trnitých keřů, stačí jeden neohrabaný pohyb a přihodíš si ošklivé zranění. Ty se ale trní ladně vyhýbáš.",
      badDescription3:
        "Kolem cesty roste mnoho trnitých keřů, stačí jeden neohrabaný pohyb a přihodíš si ošklivé zranění. Ty se ale trní ladně vyhýbáš.",
      badDescription4:
        "Kolem cesty roste mnoho trnitých keřů, stačí jeden neohrabaný pohyb a přihodíš si ošklivé zranění. Ty se ale trní ladně vyhýbáš.",
      badDescription5:
        "Kolem cesty roste mnoho trnitých keřů, stačí jeden neohrabaný pohyb a přihodíš si ošklivé zranění. Ty se ale trní ladně vyhýbáš.",
      badDescription6:
        "Kolem cesty roste mnoho trnitých keřů, stačí jeden neohrabaný pohyb a přihodíš si ošklivé zranění. Ty se ale trní ladně vyhýbáš.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
  },
  game: {
    Village: {
      name: "Bahenní vesnice",
      effect: "display",
      protection: "none",
      protectedKarma: 2,
      badKarma1: 2,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Procházíš kolem na první pohled obyčejné vesnice. Stačí ti ale jeden pohled na bytosti, které ve vesnici bydlí a hned si uvědomíš, že tohle setkání nebude patřit mezi ty nejpříjemnější. Bytosti mají ve zvyku házet po procházejících bláto. Když si k hnědé hmotě přivoníš, začínáš se modlit, aby to bylo pouze bláto.",
      badDescription1:
        "Procházíš kolem na první pohled obyčejné vesnice. Stačí ti ale jeden pohled na bytosti, které ve vesnici bydlí a hned si uvědomíš, že tohle setkání nebude patřit mezi ty nejpříjemnější. Bytosti mají ve zvyku házet po procházejících bláto. Když si k hnědé hmotě přivoníš, začínáš se modlit, aby to bylo pouze bláto.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Swamps: {
      name: "Bažiny",
      effect: "display",
      protection: "breathing-spell",
      protectedKarma: 1,
      badKarma1: 5,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Procházíš se lesem, a najednou pocítíš nepříjemný zápach. Vstupuješ na bažiny. Boty se ti začínají lepit, oči začínají slzet, vzduch je hustý, že by se ho dalo krájet.",
      badDescription1:
        "Procházíš se lesem, a najednou pocítíš nepříjemný zápach. Vstupuješ na bažiny. Boty se ti začínají lepit, oči začínají slzet a nemůžeš se zcela nadechnout. Tyhle bažinné výpary nevypadají zdravě. „Alespoň jsem tady v bezpečí“ odfrkneš si. Ale je tomu opravdu tak? Nemůžeš přestat kašlat.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Mountains: {
      name: "Hory šílenství",
      effect: "toss/toss",
      protection: "careful",
      protectedKarma: "nie dotyczy",
      badKarma1: 7,
      badKarma2: 17,
      badKarma3: 15,
      badKarma4: 18,
      badKarma5: 10,
      badKarma6: 19,
      worseKarma1: 7,
      worseKarma2: 7,
      worseKarma3: 17,
      worseKarma4: 17,
      worseKarma5: 18,
      worseKarma6: 15,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Díky auře šílenství máš novou dovednost! Slyšíš hlasy, bohužel pro Tebe, ne moc příjemné. Nutí Tě skočit dolů ze skály. Snažíš se nějak ovlivnit své chování, ale cítíš, že hlasy postupně nad Tebou přebírají kontrolu. Přicházíš k útesu a skáčeš. Ještě není nic ztraceno, pád jsi přežil, spoluhráči Tě můžou zachránit. Všichni odkládají své plány na později, prioritou je Tvoje zdraví, spoluhráči Ti spěchají na pomoc.",
      badDescription2:
        "Díky auře šílenství máš novou dovednost! Slyšíš hlasy, bohužel pro Tebe, ne moc příjemné. Nutí Tě skočit dolů ze skály. Snažíš se dostat pod kontrolu svou mysl, stojí Tě to hodně sil, ale alespoň na chvíli se ti daří zahnat sebedestruktivní myšlenky. Cítíš, že i když se ti podařilo myšlenky uspat, jednoho dne se vrátí.",
      badDescription3:
        "Díky auře šílenství máš novou dovednost! Slyšíš hlasy, bohužel pro Tebe, ne moc příjemné. Nutí Tě skočit dolů ze skály. Snažíš se dostat pod kontrolu svou mysl, stojí Tě to hodně sil, ale alespoň na chvíli se ti daří zahnat sebedestruktivní myšlenky. Cítíš, že i když se ti podařilo myšlenky uspat, jednoho dne se vrátí..",
      badDescription4:
        "Výhledy odsuď jsou opravdu pěkné, při rozjímání ale znenadání zakopneš a upadneš. Si celý potlučený. ",
      badDescription5:
        "Výhledy odsuď jsou opravdu pěkné, při rozjímání ale znenadání zakopneš a ošklivě si při pádu na kámen poraníš tvář.",
      badDescription6:
        "Cesta se zdá být monotónní, po výstupu na další horu se rozhlížíš, ale máš pocit, že jsi pořád na stejném místě. Chodíš pořád dokola, a nemůžeš najít správnou cestu.",
      worseDescription1:
        "Díky auře šílenství máš novou dovednost! Slyšíš hlasy, bohužel pro Tebe, ne moc příjemné. Nutí Tě skočit dolů ze skály. Snažíš se nějak ovlivnit své chování, ale cítíš, že hlasy postupně nad Tebou přebírají kontrolu. Přicházíš k útesu a skáčeš. Ještě není nic ztraceno, pád jsi přežil, spoluhráči Tě můžou zachránit. Všichni odkládají své plány na později, prioritou je Tvoje zdraví, spoluhráči Ti spěchají na pomoc.",
      worseDescription2:
        "Díky auře šílenství máš novou dovednost! Slyšíš hlasy, bohužel pro Tebe, ne moc příjemné. Nutí Tě skočit dolů ze skály. Snažíš se nějak ovlivnit své chování, ale cítíš, že hlasy postupně nad Tebou přebírají kontrolu. Přicházíš k útesu a skáčeš. Ještě není nic ztraceno, pád jsi přežil, spoluhráči Tě můžou zachránit. Všichni odkládají své plány na později, prioritou je Tvoje zdraví, spoluhráči Ti spěchají na pomoc.",
      worseDescription3:
        "Díky auře šílenství máš novou dovednost! Slyšíš hlasy, bohužel pro Tebe, ne moc příjemné. Nutí Tě skočit dolů ze skály. Snažíš se dostat pod kontrolu svou mysl, stojí Tě to hodně sil, ale alespoň na chvíli se ti daří zahnat sebedestruktivní myšlenky. Cítíš, že i když se ti podařilo myšlenky uspat, jednoho dne se vrátí.",
      worseDescription4:
        "Díky auře šílenství máš novou dovednost! Slyšíš hlasy, bohužel pro Tebe, ne moc příjemné. Nutí Tě skočit dolů ze skály. Snažíš se dostat pod kontrolu svou mysl, stojí Tě to hodně sil, ale alespoň na chvíli se ti daří zahnat sebedestruktivní myšlenky. Cítíš, že i když se ti podařilo myšlenky uspat, jednoho dne se vrátí.",
      worseDescription5:
        "Výhledy odsuď jsou opravdu pěkné, při rozjímání ale znenadání zakopneš a upadneš. Si celý potlučený. ",
      worseDescription6:
        "Díky auře šílenství máš novou dovednost! Slyšíš hlasy, bohužel pro Tebe, ne moc příjemné. Nutí Tě skočit dolů ze skály. Snažíš se dostat pod kontrolu svou mysl, stojí Tě to hodně sil, ale alespoň na chvíli se ti daří zahnat sebedestruktivní myšlenky. Cítíš, že i když se ti podařilo myšlenky uspat, jednoho dne se vrátí.",
    },
    Footbridge: {
      name: "Dřevěná lávka",
      effect: "display",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 8,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Procházíš přes řeku, vcházíš na lávku, je celá rozvrzaná, musíš si dávat pozor, protože víš z doslechu, že pod ní bydlí troll. Podklouzne ti noha a spadneš do vody. Trolla si svým pádem rozesmál, líbíš se mu, a tak tě nechává volně projít.",
      badDescription1:
        "Procházíš přes řeku, vcházíš na lávku, je celá rozvrzaná, musíš si dávat pozor, protože víš z doslechu, že pod ní bydlí troll. Podklouzne ti noha a spadneš do vody. Probudil jsi trolla ze spánku a je naštvaný. Schytáváš bolestivé rány, ale podařilo se ti dopravit se na druhý břeh.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Avalanche: {
      name: "Kamenná lavina",
      effect: "display/toss",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 9,
      badKarma2: 9,
      badKarma3: 9,
      badKarma4: 9,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Slyšíš hlasitý lomot seshora, jen tak tak stihneš uskočit padajícím kamenům. Uniknul jsi nebezpečí.",
      badDescription1:
        "Slyšíš hlasitý lomot seshora, stihneš akorát natočit hlavu abys na poslední chvíli viděl kámen trefující tě přímo mezi oči. Nevidíš nic, před očima se ti míhají hvězdičky a cítíš jak ti na hlavě roste obrovská boule. Tohle šíleně bolelo.",
      badDescription2:
        "Slyšíš hlasitý lomot seshora, stihneš akorát natočit hlavu abys na poslední chvíli viděl kámen trefující tě přímo mezi oči. Nevidíš nic, před očima se ti míhají hvězdičky a cítíš jak ti na hlavě roste obrovská boule. Tohle šíleně bolelo.",
      badDescription3:
        "Slyšíš hlasitý lomot seshora, stihneš akorát natočit hlavu abys na poslední chvíli viděl kámen trefující tě přímo mezi oči. Nevidíš nic, před očima se ti míhají hvězdičky a cítíš jak ti na hlavě roste obrovská boule. Tohle šíleně bolelo.",
      badDescription4:
        "Slyšíš hlasitý lomot seshora, stihneš akorát natočit hlavu abys na poslední chvíli viděl kámen trefující tě přímo mezi oči. Nevidíš nic, před očima se ti míhají hvězdičky a cítíš jak ti na hlavě roste obrovská boule. Tohle šíleně bolelo.",
      badDescription5:
        "Slyšíš hlasitý lomot seshora, jen tak tak stihneš uskočit padajícím kamenům. Uniknul jsi nebezpečí.",
      badDescription6:
        "Slyšíš hlasitý lomot seshora, jen tak tak stihneš uskočit padajícím kamenům. Uniknul jsi nebezpečí.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Generator: {
      name: "Generátor kouzel",
      effect: "generator",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 5,
      badKarma2: 15,
      badKarma3: 20,
      badKarma4: 10,
      badKarma5: 21,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Vcházíš na louku na které jsou rozmístěné podivně vypadající konstrukce. Už na první pohled víš, že tohle nemohl vytvořit obyčejný člověk. Takové budovy umějí budovat pouze mágové. Mezi sloupy se míhají kouzelné jiskry. Instinkt ti ale napovídá, že bude lepší se od nich držet z daleka.",
      badDescription1:
        "Vcházíš na louku na které jsou rozmístěné podivně vypadající konstrukce. Už na první pohled víš, že tohle nemohl vytvořit obyčejný člověk. Takové budovy umějí budovat pouze mágové. Mezi sloupy se míhají kouzelné jiskry. Líbí se ti a natahuješ k nim ruku, když v tom tě jedna z nich trefí a vyrazí ti dech. Po pár vteřinách tento nepříjemný pocit vymizel. Doufáš, že to nebude mít žádné trvalé následky.",
      badDescription2:
        "Vcházíš na louku na které jsou rozmístěné podivně vypadající konstrukce. Už na první pohled víš, že tohle nemohl vytvořit obyčejný člověk. Takové budovy umějí budovat pouze mágové. Mezi sloupy se míhají kouzelné jiskry. Líbí se ti a natahuješ k nim ruku, když v tom tě jedna z nich trefí. Najednou nemáš pojetí kde jsi ani kdo jsi. Tento pocit ale přetrvává jen chvilku. Snad to nebude mít trvalé následky.",
      badDescription3:
        "Vcházíš na louku na které jsou rozmístěné podivně vypadající konstrukce. Už na první pohled víš, že tohle nemohl vytvořit obyčejný člověk. Takové budovy umějí budovat pouze mágové. Mezi sloupy se míhají kouzelné jiskry. Líbí se ti a nahýbáš se směrem k nim. Jedna z jisker tě trefuje a pálí ti obočí. Spoluhráči se ti možná budou smát, ale obočí s časem doroste. Doufáš, že kromě obočí nebudeš mít dalších trvalých následků.",
      badDescription4:
        "Vcházíš na louku na které jsou rozmístěné podivně vypadající konstrukce. Už na první pohled víš, že tohle nemohl vytvořit obyčejný člověk. Takové budovy umějí budovat pouze mágové. Mezi sloupy se míhají kouzelné jiskry. Líbí se ti a natahuješ k nim ruku, když v tom tě jedna z nich trefuje do ruky. Spálila tě, takže asi nebudou tak neškodné jak na první pohled vypadaly. Doufáš, že kromě popálené ruky nebudeš mít dalších trvalých následků.",
      badDescription5:
        "Vcházíš na louku na které jsou rozmístěné podivně vypadající konstrukce. Už na první pohled víš, že tohle nemohl vytvořit obyčejný člověk. Takové budovy umějí budovat pouze mágové. Mezi sloupy se míhají kouzelné jiskry. Líbí se ti a natahuješ k nim ruku, když v tom tě jedna z nich trefí a odhodí o pořádný kus dozadu/vzad. Bolí tě celé tělo ale asi to nebude mít žádné trvalé následky.",
      badDescription6:
        "Vcházíš na louku na které jsou rozmístěné podivně vypadající konstrukce. Už na první pohled víš, že tohle nemohl vytvořit obyčejný člověk. Takové budovy umějí budovat pouze mágové. Mezi sloupy se míhají kouzelné jiskry. Jedna letí směrem k tobě ale stačíš se ji vyhnout.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Glade: {
      name: "Lovecká paseka",
      effect: "display",
      protection: "breastplate",
      protectedKarma: 1,
      badKarma1: 10,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Procházíš se po louce, loví na ní myslivci. Mávají směrem k Tobě, na první pohled víš, že jsi trefil na přátelské jedince.",
      badDescription1:
        "Procházíš se po louce, loví na ní myslivci. Proběhla kolem tebe liška, a myslivci si tě nevšimli, cítíš bolest v zadnici, trefili tě nechtíc šípem. Naštěstí jsi stál daleko, šíp se o tebe jenom otřel.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Ruins: {
      name: "Zchátralá ruina",
      effect: "display",
      protection: "none",
      protectedKarma: 3,
      badKarma1: 3,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Rozhodl ses zkrátit si cestu přes zchátralé panství. Opatrně překračuješ kameny, které byly kdysi částí teď už staré rozpadající se budovy. Kde se vzal, tu se vzal, a z ničeho nic stojíš tváři v tvář ze starým zanedbaným dědkem. Nelíbí se mu, že se procházíš po jeho pozemku, a proklíná tě. Ještě dlouho po tomto setkání se ti třesou hrůzou ruce, nikdy jsi od nikoho neslyšel takové slova.",
      badDescription1:
        "Rozhodl ses zkrátit si cestu přes zchátralé panství. Opatrně překračuješ kameny, které byly kdysi částí teď už staré rozpadající se budovy. Kde se vzal, tu se vzal, a z ničeho nic stojíš tváři v tvář ze starým zanedbaným dědkem. Nelíbí se mu, že se procházíš po jeho pozemku, a proklíná tě. Ještě dlouho po tomto setkání se ti třesou hrůzou ruce, nikdy jsi od nikoho neslyšel takové slova.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Forest: {
      name: "Temný les",
      effect: "display",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 1,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Hned po tom co jsi vešel do temného lesa, začínáš přemýšlet, jestli to byl dobrý nápad, přece jenom i obyčejných lesů se bojíš, a tenhle ani z daleka není obyčejný. V jednom kuse se ohlížíš za sebe a čekáš až na tebe něco vyskočí. Naštěstí už mezi stromy vidíš první prameny slunce. Musíš být blízko, ještě pár kroků a jsi v bezpečí.",
      badDescription1:
        "Hned po tom co jsi vešel do temného lesa, začínáš přemýšlet, jestli to byl dobrý nápad, přece jenom i obyčejných lesů se bojíš, a tenhle ani z daleka není obyčejný. V jednom kuse se ohlížíš za sebe a čekáš až na tebe něco vyskočí. Naštěstí už mezi stromy vidíš první prameny slunce. Musíš být blízko, ještě pár kroků a jsi v bezpečí.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Crossing: {
      name: "Bouřlivá řeka",
      effect: "toss/toss",
      protection: "breathing-spell",
      protectedKarma: "nie dotyczy",
      badKarma1: 11,
      badKarma2: 11,
      badKarma3: 22,
      badKarma4: 22,
      badKarma5: 6,
      badKarma6: 5,
      worseKarma1: 11,
      worseKarma2: 11,
      worseKarma3: 11,
      worseKarma4: 11,
      worseKarma5: 22,
      worseKarma6: 6,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Když zkoušíš plavat, řeka tě unáší z proudem, dostáváš se k jezu který tě nemilosrdně spolknul a protáčí tě kolem dokola. Nemůžeš se nadechnout, nebýt pomoci procházejících vesničanů byl by jsi se utopil. Děkuješ jim za pomoc, vykašlujíc zbytky vody kterou jsi vypil. Jsi unavený, tvoje tělo bude potřebovat čas na regeneraci, jsi pomalejší a na všechno je ti potřeba více času.",
      badDescription2:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Když zkoušíš plavat, řeka tě unáší z proudem, dostáváš se k jezu který tě nemilosrdně spolknul a protáčí tě kolem dokola. Nemůžeš se nadechnout, nebýt pomoci procházejících vesničanů byl by jsi se utopil. Děkuješ jim za pomoc, vykašlujíc zbytky vody kterou jsi vypil. Jsi unavený, tvoje tělo bude potřebovat čas na regeneraci, jsi pomalejší a na všechno je ti potřeba více času.",
      badDescription3:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Naštěstí umíš plavat. Párkrát tě silný proud stáhne pod vodu, ale nakonec se ti podaří osvobodit se ze spárů nebezpečné vody. Cítíš, že nechybělo moc a skončil bys na dně řeky. Už necítíš takovou pohodu jak kdysi.",
      badDescription4:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Naštěstí umíš plavat. Párkrát tě silný proud stáhne pod vodu, ale nakonec se ti podaří osvobodit se ze spárů nebezpečné vody. Cítíš, že nechybělo moc a skončil bys na dně řeky. Už necítíš takovou pohodu jak kdysi.",
      badDescription5:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Proud ti podrazil nohy, ale naštěstí jsi výborný plavec. Doplavat ke břehu tě sice stojí hodně sil, ale jsi naživu. Cestou spolkneš hodně vody a vykašláváš ji ještě dlouho po téhle zkušenosti.",
      badDescription6:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou.  Doplavat ke břehu tě sice stojí hodně sil, ale jsi naživu. Cestou spolkneš hodně vody a vykašláváš ji ještě dlouho po téhle zkušenosti.",
      worseDescription1:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Když zkoušíš plavat, řeka tě unáší z proudem, dostáváš se k jezu který tě nemilosrdně spolknul a protáčí tě kolem dokola. Nemůžeš se nadechnout, nebýt pomoci procházejících vesničanů byl by jsi se utopil. Děkuješ jim za pomoc, vykašlujíc zbytky vody kterou jsi vypil. Jsi unavený, tvoje tělo bude potřebovat čas na regeneraci, jsi pomalejší a na všechno je ti potřeba více času.",
      worseDescription2:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Když zkoušíš plavat, řeka tě unáší z proudem, dostáváš se k jezu který tě nemilosrdně spolknul a protáčí tě kolem dokola. Nemůžeš se nadechnout, nebýt pomoci procházejících vesničanů byl by jsi se utopil. Děkuješ jim za pomoc, vykašlujíc zbytky vody kterou jsi vypil. Jsi unavený, tvoje tělo bude potřebovat čas na regeneraci, jsi pomalejší a na všechno je ti potřeba více času.",
      worseDescription3:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Když zkoušíš plavat, řeka tě unáší z proudem, dostáváš se k jezu který tě nemilosrdně spolknul a protáčí tě kolem dokola. Nemůžeš se nadechnout, nebýt pomoci procházejících vesničanů byl by jsi se utopil. Děkuješ jim za pomoc, vykašlujíc zbytky vody kterou jsi vypil. Jsi unavený, tvoje tělo bude potřebovat čas na regeneraci, jsi pomalejší a na všechno je ti potřeba více času.",
      worseDescription4:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Když zkoušíš plavat, řeka tě unáší z proudem, dostáváš se k jezu který tě nemilosrdně spolknul a protáčí tě kolem dokola. Nemůžeš se nadechnout, nebýt pomoci procházejících vesničanů byl by jsi se utopil. Děkuješ jim za pomoc, vykašlujíc zbytky vody kterou jsi vypil. Jsi unavený, tvoje tělo bude potřebovat čas na regeneraci, jsi pomalejší a na všechno je ti potřeba více času.",
      worseDescription5:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Naštěstí umíš plavat. Párkrát tě silný proud stáhne pod vodu, ale nakonec se ti podaří osvobodit se ze spárů nebezpečné vody. Cítíš, že nechybělo moc a skončil bys na dně řeky. Už necítíš takovou pohodu jak kdysi.",
      worseDescription6:
        "Na první pohled klidná řeka, ale když jsi po pás ve vodě, cítíš silné spodní proudy, máš problém se udržet na nohou. Proud ti podrazil nohy, ale naštěstí jsi výborný plavec. Doplavat ke břehu tě sice stojí hodně sil, ale jsi naživu. Cestou spolkneš hodně vody a vykašláváš ji ještě dlouho po téhle zkušenosti.",
    },
    Dragon: {
      name: "Drak",
      effect: "display",
      protection: "antiflame-spell",
      protectedKarma: 4,
      badKarma1: 12,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Procházíš se kolem dračí jámy, praskne ti pod nohou větev a neštěstí je na světě. Probudil jsi draka. Ten vylétá ze své jámy a chrlí oheň na Dračí Teritorium.",
      badDescription1:
        "Procházíš se kolem dračí jámy, praskne ti pod nohou větev a neštěstí je na světě. Probudil jsi draka. Ten vylétá ze své jámy a chrlí oheň na Dračí Teritorium.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Appiary: {
      name: "Starý včelín",
      effect: "toss/toss",
      protection: "careful",
      protectedKarma: "nie dotyczy",
      badKarma1: 13,
      badKarma2: 2,
      badKarma3: 2,
      badKarma4: 2,
      badKarma5: 20,
      badKarma6: 20,
      worseKarma1: 13,
      worseKarma2: 13,
      worseKarma3: 13,
      worseKarma4: 2,
      worseKarma5: 2,
      worseKarma6: 2,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Naštval jsi zmutované jedovaté včely. Včely se zaměřily primárně na tebe ale spousta z nich se rozlétla po celé krajině. Jsi nejvíc dobodaný ze všech, ale včely se dostaly i k ostatním hráčům. Všichni si vytahujete bolestivá žihadla z těla. Odteď si všichni každý den musíte připravovat speciální odvar, který je časově velmi náročný na přípravu.",
      badDescription2:
        "Naštval jsi včely. Vyletěly z úlů a bodají tě do tváře. Jsi celý oteklý, změnil jsi se k nepoznáni.",
      badDescription3:
        "Naštval jsi včely. Vyletěly z úlů a bodají tě do tváře. Jsi celý oteklý, změnil jsi se k nepoznáni.",
      badDescription4:
        "Naštval jsi včely. Vyletěly z úlů a bodají tě do tváře. Jsi celý oteklý, změnil jsi se k nepoznáni.",
      badDescription5:
        "Naštval jsi včely. Vyletěly z úlů a bodají tě do tváře. Jsi celý oteklý, změnil jsi se k nepoznáni.",
      badDescription6:
        "Naštval jsi včely. Vyletěly z úlů a bodají tě do tváře. Jsi celý oteklý, změnil jsi se k nepoznáni.",
      worseDescription1:
        "Naštval jsi zmutované jedovaté včely. Včely se zaměřily primárně na tebe ale spousta z nich se rozlétla po celé krajině. Jsi nejvíc dobodaný ze všech, ale včely se dostaly i k ostatním hráčům. Všichni si vytahujete bolestivá žihadla z těla. Odteď si všichni každý den musíte připravovat speciální odvar, který je časově velmi náročný na přípravu.",
      worseDescription2:
        "Naštval jsi zmutované jedovaté včely. Včely se zaměřily primárně na tebe ale spousta z nich se rozlétla po celé krajině. Jsi nejvíc dobodaný ze všech, ale včely se dostaly i k ostatním hráčům. Všichni si vytahujete bolestivá žihadla z těla. Odteď si všichni každý den musíte připravovat speciální odvar, který je časově velmi náročný na přípravu.",
      worseDescription3:
        "Naštval jsi zmutované jedovaté včely. Včely se zaměřily primárně na tebe ale spousta z nich se rozlétla po celé krajině. Jsi nejvíc dobodaný ze všech, ale včely se dostaly i k ostatním hráčům. Všichni si vytahujete bolestivá žihadla z těla. Odteď si všichni každý den musíte připravovat speciální odvar, který je časově velmi náročný na přípravu.",
      worseDescription4:
        "Naštval jsi včely. Vyletěly z úlů a bodají tě do tváře. Jsi celý oteklý, změnil jsi se k nepoznáni.",
      worseDescription5:
        "Naštval jsi včely. Vyletěly z úlů a bodají tě do tváře. Jsi celý oteklý, změnil jsi se k nepoznáni.",
      worseDescription6:
        "Naštval jsi včely. Vyletěly z úlů a bodají tě do tváře. Jsi celý oteklý, změnil jsi se k nepoznáni.",
    },
    Slippery: {
      name: "Náledí",
      effect: "display/toss",
      protection: "careful",
      protectedKarma: 1,
      badKarma1: 14,
      badKarma2: 23,
      badKarma3: 23,
      badKarma4: 23,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Dneska je opravdu nepříznivé počasí na takovou vycházku. Cesta klouže, ale podařilo se ti ji bezpečně projít.",
      badDescription1:
        "Dneska je opravdu nepříznivé počasí na takovou vycházku. Cesta klouže a ty se o tom přesvědčuješ na vlastní kůži. Podklouzla ti noha a ty jsi celou svou váhou dopadl na tvrdý led. Nic vážnějšího se ti naštěstí nestalo, jsi jenom potlučený a celou svou energií vkládáš do toho, aby ses zvedl. Kromě toho, bolestí chvíli kulháš.",
      badDescription2:
        "Dneska je opravdu nepříznivé počasí na takovou vycházku. Cesta klouže a ty se o tom přesvědčuješ na vlastní kůži. Podklouzla ti noha a ty jsi celou svou váhou dopadl na tvrdý led. Nic vážnějšího se ti naštěstí nestalo, jenom od bolesti chvíli kulháš. Můžeš se vydat za lékařem NEBO zatnout zuby a pokračovat dál – přece jenom jsi jenom potlučený.",
      badDescription3:
        "Dneska je opravdu nepříznivé počasí na takovou vycházku. Cesta klouže a ty se o tom přesvědčuješ na vlastní kůži. Podklouzla ti noha a ty jsi celou svou váhou dopadl na tvrdý led. Nic vážnějšího se ti naštěstí nestalo, jenom od bolesti chvíli kulháš. Můžeš se vydat za lékařem NEBO zatnout zuby a pokračovat dál – přece jenom jsi jenom potlučený.",
      badDescription4:
        "Dneska je opravdu nepříznivé počasí na takovou vycházku. Cesta klouže a ty se o tom přesvědčuješ na vlastní kůži. Podklouzla ti noha a ty jsi celou svou váhou dopadl na tvrdý led. Nic vážnějšího se ti naštěstí nestalo, jenom od bolesti chvíli kulháš. Můžeš se vydat za lékařem NEBO zatnout zuby a pokračovat dál – přece jenom jsi jenom potlučený.",
      badDescription5:
        "Dneska je opravdu nepříznivé počasí na takovou vycházku. Cesta klouže, ale podařilo se ti ji bezpečně projít.",
      badDescription6:
        "Dneska je opravdu nepříznivé počasí na takovou vycházku. Cesta klouže, ale podařilo se ti ji bezpečně projít.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Wilderness: {
      name: "Lesní mýtina ",
      effect: "display",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 15,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Z doslechu víš, že na této mýtině kolem potoka kdysi někdo spatřil rusalku. Nepodloženým pověstem ale nevěříš. Přesto v tobě zůstává jiskra dobrodružství a chtěl bys alespoň jednou v životě rusalku spatřit. Zpěv rusalek ale přes přilbici neslyšíš a tak se rozhodneš pokračovat dál.",
      badDescription1:
        "Z doslechu víš, že na této mýtině kolem potoka kdysi někdo spatřil rusalku. Najednou slyšíš krásný zpěv, to musí byt ona! Bohužel spěcháš, a tak se do lákavého zpěvu nemůžeš dál zaposlouchávat. Nebo snad ano? Krásná písnička ti pořád zní v hlavě.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Volcano: {
      name: "Sopka",
      effect: "toss/toss",
      protection: "antiflame-spell",
      protectedKarma: "nie dotyczy",
      badKarma1: 16,
      badKarma2: 16,
      badKarma3: 10,
      badKarma4: 10,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: 24,
      worseKarma2: 24,
      worseKarma3: 16,
      worseKarma4: 16,
      worseKarma5: 10,
      worseKarma6: 10,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Rychle uskočíš a chytíš se skály abys uniknul pádu. Skála ti ale poraní ruce. Aby toho nebylo málo, po dopadu kusů chodníku do lávy, sopka zabublá a vypálí ti při tom tečky do tváře.",
      badDescription2:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Rychle uskočíš a chytíš se skály abys uniknul pádu. Skála ti ale poraní ruce. Aby toho nebylo málo, po dopadu kusů chodníku do lávy, sopka zabublá a vypálí ti při tom tečky do tváře.",
      badDescription3:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Rychle uskočíš a chytíš se skály abys uniknul pádu. Vyškrábat se zpět na vrchol kráteru je už pro tebe hračka. Ostré skály ti ale ošklivě poranily ruce.",
      badDescription4:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Rychle uskočíš a chytíš se skály abys uniknul pádu. Vyškrábat se zpět na vrchol kráteru je už pro tebe hračka. Ostré skály ti ale ošklivě poranily ruce.",
      badDescription5:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Podařilo se ti uskočit na bezpečnou cestu. Tvoje ostražitost ti nejspíš zachránila, život.",
      badDescription6:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Podařilo se ti uskočit na bezpečnou cestu. Tvoje ostražitost ti nejspíš zachránila, život.",
      worseDescription1:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Rychle uskočíš a chytíš se skály abys uniknul pádu. Skála ti ale poraní ruce. Aby toho nebylo málo, po dopadu kusů chodníku do lávy, sopka zabublá a vypálí ti při tom tečky do tváře.",
      worseDescription2:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Rychle uskočíš a chytíš se skály abys uniknul pádu. Skála ti ale poraní ruce. Aby toho nebylo málo, po dopadu kusů chodníku do lávy, sopka zabublá a vypálí ti při tom tečky do tváře.",
      worseDescription3:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Rychle uskočíš a chytíš se skály abys uniknul pádu. Skála ti ale poraní ruce. Aby toho nebylo málo, po dopadu kusů chodníku do lávy, sopka zabublá a vypálí ti při tom tečky do tváře.",
      worseDescription4:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Rychle uskočíš a chytíš se skály abys uniknul pádu. Skála ti ale poraní ruce. Aby toho nebylo málo, po dopadu kusů chodníku do lávy, sopka zabublá a vypálí ti při tom tečky do tváře.",
      worseDescription5:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Rychle uskočíš a chytíš se skály abys uniknul pádu. Vyškrábat se zpět na vrchol kráteru je už pro tebe hračka. Ostré skály ti ale ošklivě poranily ruce.",
      worseDescription6:
        "Stezka prochází hranou kráteru. Hlavou se ti mihne myšlenka, že tohle nevypadá zrovna bezpečně, když v tom ti pod nohama začne praskat cestička. Rychle uskočíš a chytíš se skály abys uniknul pádu. Vyškrábat se zpět na vrchol kráteru je už pro tebe hračka. Ostré skály ti ale ošklivě poranily ruce.",
    },
  },
};
